import classnamesPackage from "classnames"

export const classNames = classnamesPackage
